'use strict';
/**
 * Exports acl-related constants
 * @module modes
 */

var vocab = require('solid-namespace');
var ns = vocab();

// ACL access modes
var READ = ns.acl('Read');
var WRITE = ns.acl('Write');
var APPEND = ns.acl('Append');
var CONTROL = ns.acl('Control');
var EVERYONE = ns.foaf('Agent');
var ALL_MODES = [READ, WRITE, CONTROL];

// ACL-related convenience constants
var INHERIT = true;
var NOT_INHERIT = !INHERIT;
var ACCESS_TO = 'accessTo';
var DEFAULT = 'default';

module.exports.acl = {
  ALL_MODES: ALL_MODES,
  READ: READ,
  WRITE: WRITE,
  APPEND: APPEND,
  CONTROL: CONTROL,
  EVERYONE: EVERYONE,
  INHERIT: INHERIT,
  NOT_INHERIT: NOT_INHERIT,
  ACCESS_TO: ACCESS_TO,
  DEFAULT: DEFAULT
};


//////////////////
// WEBPACK FOOTER
// ./~/solid-permissions/lib/modes.js
// module id = 170
// module chunks = 0